import * as React from 'react';
import { ReactComponent as AsurionLogo } from './AsurionTechCareSalesLogo.svg';

export const AsurionTechCareSalesLogo = () => <AsurionLogo />;

export default AsurionTechCareSalesLogo;
